import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import imagem from "../../shared/assets/logoCard.svg"
import { getMeusAnuncios } from "../../services/apiUsuario";
import { getImagensAnuncio } from "../../services/apiImagem";
import { getTodasCidades } from "../../services/apiCidade";
import notFound from "./notFound.svg";
import "./meuAnuncioCard.css";
import Image from 'react-bootstrap/Image';
import { Grid } from "swiper/modules";

interface Anuncio {
  nmAnuncio: string;
  cdAnuncio: number;
  cdUsuario: number;
  cdCidade: number;
  dsAnuncio: string;
  dmTipoAnuncio: boolean;
  dtPublicacao: string;
  dmAtivo: boolean;
  vlAnuncio: any;
  imageUrl?: any;
}

interface MeusAnunciosProps {
  ativos: boolean;
}

export default function MeusAnuncios({ ativos }: MeusAnunciosProps) {
  const cdUsuario = localStorage.getItem("cdUsuario");
  const [anuncios, setAnuncios] = useState<Anuncio[]>([]);
  const [cidades, setCidades] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isHovered, setIsHovered] = useState<number | null>(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [dtPublicacao, setDtPublicacao] = useState<string[]>([]);

  const fetchImagemPrincipal = async (anuncio: Anuncio) => {
    try {
      const response = await getImagensAnuncio(anuncio.cdAnuncio);
      if (response && response.length > 0) {
        const imagemPrincipal = response[0];
        const imageUrl = `data:image/${imagemPrincipal.nmTipoArquivo};base64,${imagemPrincipal.mdArquivo}`;
        anuncio.imageUrl = imageUrl.toString();
      }
      return anuncio;
    } catch (error) {
      return anuncio;
    }
  };
  const fetchCidades = async () => {
    try {
      const response = await getTodasCidades();
      setCidades(response);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    setLoading(true);
    setShowSpinner(true);
    setAnuncios([]);
    const fetchData = async () => {
      try {
        const response = await getMeusAnuncios(Number(cdUsuario), ativos);
        if (response.data.length > 0) {
          fetchCidades();
          const anunciosComImagens = await Promise.all(
            response.data.map(async (anuncio: Anuncio) => {
              const anuncioComImagem = await fetchImagemPrincipal(anuncio);
              return anuncioComImagem;
            })
          );
          setAnuncios(anunciosComImagens);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setShowSpinner(false);
        setLoading(false);
      }
    };
    fetchData();
  }, [ativos, cdUsuario]);

  if (anuncios.length === 0 && !showSpinner) {
    return (
      <div
        className="d-flex justify-content-center align-items-center text-center"
        style={{ minHeight: "40vh" }}
      >
        <div>
          <h5 className="mb-1">Nenhum anúncio aqui...</h5>
          <img
            src={notFound}
            className="mx-auto"
            style={{
              maxHeight: "100%",
              width: "10rem",
              objectFit: "cover",
            }}
            alt="Imagem não encontrada"
          />
        </div>
      </div>
    );
  }

  if (showSpinner) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "40vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
  const dataAtual = new Date().toISOString().split("T")[0];

  return (
    <div className="container-sm mt-2">
      <div className="anuncios-container">
        {anuncios.map((anuncio) => {
          const tipoAnuncio = anuncio.dmTipoAnuncio ? "Produto" : "Serviço";
          return (
            <Link
              to={`/milshop/anuncio/ver-detalhes/${anuncio.cdAnuncio}`}
              className="custom-link-style"
              onMouseEnter={() => setIsHovered(anuncio.cdAnuncio)}
              onMouseLeave={() => setIsHovered(null)}
              key={anuncio.cdAnuncio}
            >
              <div
                className={`row mt-3 custom-rounded bkCard  ${isHovered === anuncio.cdAnuncio ? "hovered" : ""}   ${new Date(anuncio.dtPublicacao).toISOString().split("T")[0] > dataAtual ? 'bkDataPublicacao' : ''}`}
              >
                <div className="col-12 col-md-3 containerImagem">
                  {(anuncio.imageUrl !== "data:image/undefined;base64,undefined") ? (
                    <Image src={anuncio.imageUrl} alt={anuncio.nmAnuncio} style={{  }} thumbnail className={`${new Date(anuncio.dtPublicacao).toISOString().split("T")[0] > dataAtual ? 'imagemDtPublicacao' : ''} imagemMeusAnuncio`} />
                  ) : (
                    <Image
                      src={imagem}
                      alt={anuncio.nmAnuncio}
                      style={{
                        maxHeight: "10rem",
                        width: "100%",
                        objectFit: "contain",
                        background: '#050a30',
                        border: '1px solid #d69909',
                        padding: '0',
                        borderRadius: '4px'
                      }}
                      thumbnail
                    />
                  )}
                </div>

                <div
                  className="col-12 col-md-6 p-1 d-flex flex-column justify-content-between"
                  style={{
                    height: "10rem",
                  }}
                >
                  <h5 className="text-truncate mb-1 ps-2 pt-2">
                    {anuncio.nmAnuncio}
                  </h5>
                  <p className="two-line-clamp ps-2">{anuncio.dsAnuncio}</p>
                  <div
                    className="tipoCidadeEDtPublicacao text-muted"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <span className="pe-1 ps-2">{tipoAnuncio} - </span>
                    {cidades.map((cidade) => (
                      <span key={cidade.cdCidade}>
                        {anuncio.cdCidade === cidade.cdCidade &&
                          cidade.nmCidade}
                      </span>
                    ))}
                    {new Date(anuncio.dtPublicacao).toISOString().split("T")[0] > dataAtual && <p className="dataAnuncio">Aguardando Publicação...</p>}
                  </div>
                </div>
                <div className="d-flex flex-column col-12 col-md-3 p-1 text-end pe-4 justify-content-between pt-2">
                  <p>R$ {anuncio.vlAnuncio.toFixed(2)}</p>
                  <div>
                    <Link to={`/milshop/anuncio/ver-detalhes/${anuncio.cdAnuncio}`}>
                      <FontAwesomeIcon
                        icon={faEye}
                        className="me-2"
                        style={{ color: "#002f52" }}
                      />
                    </Link>
                    <Link to={`/milshop/anuncio/alterar/${anuncio.cdAnuncio}`}>
                      <FontAwesomeIcon
                        icon={faPen}
                        className="me-2"
                        style={{ color: "#002f52" }}
                      />
                    </Link>
                    <Link to={`/milshop/anuncio/excluir/${anuncio.cdAnuncio}`}>
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ color: "var(--danger)" }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
